import { useAuth0 } from '@auth0/auth0-react';
import React from 'react'
import { Helmet } from 'react-helmet-async';

function Login() {


  
    const { isAuthenticated, loginWithRedirect } = useAuth0();
  
    const handleClickFreePlan = () => {
      if (!isAuthenticated) {
        alert('Already Activated');
      } else {
        alert('but, You are Premium user ');
      }
    };
  
    const handleClickPremiumPlan = async () => {
      if (!isAuthenticated) {
        alert("You Are Premium user.\nNow, You can't Change to Free Plan   ");
      } else {
        alert('Login First');
        try {
          await loginWithRedirect();
        } catch (error) {
          console.error('Error during authentication:', error);
          alert('There was an error during authentication. Please try again later.');
        }
      }
     
      
    };
  
    return (
      <>
      <Helmet>
        <title>Log In and Access Your Account with Ease</title>
        <meta property="og:title" content="Log In and Access Your Account with Ease"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/user-profile"/>
        <meta property="og:description" content="Log in to our site with ease and access all the features and benefits of your account. Our login page is designed to make it simple and straightforward to sign in and get started. With a secure login process, you can rest assured that your personal information is protected. Once you're logged in, you can view your account information, manage your orders, and take advantage of exclusive member benefits. If you have any issues logging in, our customer support team is always available to assist you."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>
        <link rel="canonical" href="https://desireStore.online/login" />

        <meta name="title" content="Log In and Access Your Account with Ease"/>
        <meta name="description" data-rh="true" content="Log in to our site with ease and access all the features and benefits of your account. Our login page is designed to make it simple and straightforward to sign in and get started. With a secure login process, you can rest assured that your personal information is protected. Once you're logged in, you can view your account information, manage your orders, and take advantage of exclusive member benefits. If you have any issues logging in, our customer support team is always available to assist you."/>
        <meta name="keywords" content="Login page, sign in, secure, personal information, account information, manage orders, member benefits, customer support."/>
      </Helmet>
      <div className="container">

        <div className="Login">
          <div className="content">
            <div className="title">Start for Free</div>
            <div className="price">Free</div>
            <div className="description">
              <li>Get Access to Basic Features</li>
              <li>No Credit Card Required</li>
              <li>Easy and Simple Sign-up Process</li>
            </div>
          </div>
          <button disabled={isAuthenticated} onClick={handleClickFreePlan}>
            {isAuthenticated ? 'You Are Premium user' : 'Get Started'}
          </button>
        </div>
        <div className="Login">
          <div className="content">
            <div className="title">Upgrade to Premium</div>
            <div className="price">$0.00</div>
            <div className="description">
              <li>Unlock Premium Features</li>
              <li>Autofill Name & Email</li>
              <li>No Payment/Card Required</li>
              <li>Get Started with Ease</li>
            </div>
          </div>
          <button onClick={handleClickPremiumPlan}>
            {isAuthenticated ? 'Already Activated' : 'Upgrade Now'}
          </button>
        </div>
      </div></>
    );
  }


export default Login
